import { type SearchRequest } from '@searchkit/api';

import { getMatchupCentreSorting } from '~/search-domain/pipelines/match-centre/query-config';
import { createQueryFactory } from '~/search-domain/pipelines/match-centre/query-factory';
import { type SearchDomainContext } from '~/search-domain/types';
import { isFacetOnlyRequest, normalizeFacetFilters, withRequestParams } from '~/search-domain/utils';

export function buildMatchupCentreQuery(context: SearchDomainContext, searchRequest: SearchRequest) {
  // Facet-only requests read nothing but the searchkit-generated facet aggregations, so they must not
  // carry the subevents tree. See isFacetOnlyRequest.
  if (isFacetOnlyRequest(searchRequest)) {
    return searchRequest;
  }

  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mappedSearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getMatchupCentreSorting(context);

  return createQueryFactory({
    context,
    searchRequest: mappedSearchRequest,
    sorting,
  });
}
